/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  PresenterAggregateDepreciationResultResponse,
  PresenterDepreciationResultsAdjustAdjustmentResponse,
  PresenterError,
  PresenterResponse,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class DepreciationResults<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * @description Aggregate depreciation result
   *
   * @tags depreciation_results
   * @name AggregateList
   * @summary Aggregate the depreciation result
   * @request GET:/depreciation_results/aggregate
   */
  aggregateList = (
    query: {
      /** @default "category" */
      aggregation_method?: "category" | "department";
      ledger_setting_id: number;
      mode?: 0 | 1;
      term_id: number;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterAggregateDepreciationResultResponse;
      },
      PresenterError
    >({
      path: `/depreciation_results/aggregate`,
      method: "GET",
      query: query,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Get adjustment history by operation id
   *
   * @tags depreciation_results
   * @name DepreciationResultsDetail
   * @summary Get adjustment history by operation id
   * @request GET:/depreciation_results/{id}
   */
  depreciationResultsDetail = (id: number, params: RequestParams = {}) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterDepreciationResultsAdjustAdjustmentResponse;
      },
      PresenterError
    >({
      path: `/depreciation_results/${id}`,
      method: "GET",
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Aggregate depreciation result
   *
   * @tags depreciation_results
   * @name DepreciationResultsAggregateList
   * @summary Aggregate the depreciation result
   * @request GET:/monthly_closing/depreciation_results/aggregate
   */
  depreciationResultsAggregateList = (
    query: {
      /** @default "category" */
      aggregation_method?: "category" | "department";
      ledger_setting_id: number;
      mode?: 0 | 1;
      term_id: number;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterAggregateDepreciationResultResponse;
      },
      PresenterError
    >({
      path: `/monthly_closing/depreciation_results/aggregate`,
      method: "GET",
      query: query,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
}
